import { TimeLagForm } from "../types/timeLag.types";

export const buildTimeLagPayload = (
  form: TimeLagForm,
  company: number
) => [
  { company, vertical: 1, module: "RFQ", time_lag_days: form.glazing_rfq_time_lag },
  { company, vertical: 1, module: "SALES", time_lag_days: form.glazing_sales_team_time_lag },

  { company, vertical: 3, module: "Lixil", time_lag_days: form.lixil_lixil_time_lag },
  { company, vertical: 3, module: "HATCHWAY SALES", time_lag_days: form.lixil_hatchway_time_lag },

  { company, vertical: 2, module: "RFQ", time_lag_days: form.hunter_douglas_rfq_time_lag },
  { company, vertical: 2, module: "SALES", time_lag_days: form.hunter_douglas_sales_team_time_lag },
];
